import React from 'react';

import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';

import Typography from '@ts-core/components/Typography';

export interface SubjectItemListCardProps<TItem extends object> {
  loading?: boolean;
  item?: TItem;
  getName?: (item?: TItem) => React.ReactNode;
  getBackgroundImage?: (item?: TItem) => string;

  onClick: React.EventHandler<any>;
}

const SubjectItemListCard = <TItem extends object>(props: SubjectItemListCardProps<TItem>) => {
  const { item, getName, loading, onClick } = props;

  return (
    <Box position="relative">
      <ButtonBase
        disabled={loading}
        component="div"
        onClick={onClick}
        disableRipple
        sx={(theme) => ({
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          borderRadius: 2,
          overflow: 'hidden',
          padding: theme.spacing(1),
          width: '100%',
          height: '100%',
          minHeight: 62,
          backgroundColor: loading ? theme.palette.grey[200] : theme.palette.background.paper,
          boxShadow: theme.shadows[loading ? 0 : 1],
          transition: theme.transitions.create('box-shadow', {
            duration: theme.transitions.duration.standard,
          }),
          '&:hover': {
            boxShadow: theme.shadows[loading ? 0 : 2],
          },
        })}
      >
        <Typography variant="subtitle2" color="inherit" loading={loading} skeletonProps={{ width: 80 }}>
          {getName?.(item)}
        </Typography>
      </ButtonBase>
    </Box>
  );
};

export default SubjectItemListCard;
